import React, { useEffect, useState } from 'react';
import { Form, Input, Select } from 'antd';

const { Option } = Select;

const CArticuloJugueteEmpresa = () => {
  const [auxiliares, setAuxiliares] = useState({ materiales: [], generos: [] });

  useEffect(() => {
    const fetchAuxiliares = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/juguete/auxiliares`);
        const data = await res.json();
        setAuxiliares(data);
      } catch (error) {
        console.error('Error al cargar auxiliares de juguete:', error);
      }
    };
    fetchAuxiliares();
  }, []);

  return (
    <>
      <Form.Item name="edad_recomendada" label="Edad Recomendada">
        <Input />
      </Form.Item>

      <Form.Item name="material" label="Material">
        <Select placeholder="Seleccione un material">
          {auxiliares.materiales.map(m => (
            <Option key={m.mat_id} value={m.mat_nombre}>{m.mat_nombre}</Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item name="necesita_pilas" label="¿Necesita Pilas?">
        <Select placeholder="Seleccione una opción">
          <Option value={true}>Sí</Option>
          <Option value={false}>No</Option>
        </Select>
      </Form.Item>

      <Form.Item name="genero_juguete" label="Género del Juguete">
        <Select placeholder="Seleccione un género">
          {auxiliares.generos.map(g => (
            <Option key={g.gen_id} value={g.gen_nombre}>{g.gen_nombre}</Option>
          ))}
        </Select>
      </Form.Item>
    </>
  );
};

export default CArticuloJugueteEmpresa;